import { Container } from '@mui/material';
import FragenPage from './FragenPage';
import { fetchQuestionsHandler } from '../ResponseHandlers/fetchQuestionsHandler';
import { useState, useEffect } from 'react';
import InProgress from '../components/InProgress';

function GeneralPage() {
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchQuestionsData = async () => {
            try {
                setLoading(true);
                const data = await fetchQuestionsHandler({ selectedOption: 0 });
                setQuestions(data);
            } catch (error) {
                console.error('Failed to fetch State Questions:', error);
            } finally {
                setLoading(false); // Set loading to false after fetch completes
            }
        };

        fetchQuestionsData(); // Call the function inside useEffect
    }, []); // Empty dependency array ensures this runs once when the component mounts
    // console.log(questions);

    return (
        <Container>
            {loading ? <InProgress /> : <FragenPage questions={questions} />}
        </Container>
    );
}
export default GeneralPage;
